@if (devices.length && !hidden) {
  <section class="ut-dash-card" aria-labelledby="dashboardRequestedTitle">
    <!-- Focused after "Helpful?", which removes the button the tester was on. -->
    <h2 class="ut-dash-card__heading" id="dashboardRequestedTitle" tabindex="-1">Top requested devices in your area</h2>
    <div class="ut-dash-scroll">
      <ol class="ut-dash-scroll__list" utScrollFocus aria-labelledby="dashboardRequestedTitle">
        @for (device of devices; track $index) {
          <li class="ut-dash-device">
            <span class="ut-dash-icon" aria-hidden="true">
              <i class="material-icons mobile-device"></i>
            </span>
            <span class="ut-dash-device__name">{{ device.device_name }}</span>
          </li>
        }
      </ol>
    </div>
    @if (askForFeedback) {
      <div class="requested__feedback" role="group" aria-label="Was this list helpful?">
        <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm" (click)="helpful()">Helpful?</button>
        <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm" (click)="notHelpful()">Not helpful?</button>
      </div>
    }
  </section>
}
<!-- Outside the card, so "Not helpful?" can still be confirmed after the card is gone. -->
<p class="sr-only" role="status">{{ thanks }}</p>
